<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="tree-view__controls">
    <div class="tree-view__left-controls">
        @if (selectedFolder() && !selectedFolder().isRoot()) {
            <winde-ctx-sensitive-help placement="right" class="btn--view" tooltipTextPath="projects.folder.btn.moveToParent">
                <button (click)="selectParentFolder()" windeActionIcon>
                    <sui-svg-icon class="btn-back" icon="arrow-left" windeOrange/>
                </button>
            </winde-ctx-sensitive-help>
        }
        @if (!isBugReportsFolderSelected()) {
            <div class="actions" *windeHasAnyAuthority="userAuthorities.PROJECT_EDIT">
                <div
                        class="dropdown"
                        (mouseout)="showSelection(false)"
                        (blur)="showSelection(false)"
                        (mouseover)="showSelection(true)"
                        (focus)="showSelection(true)"
                >
                    <button class="add-folder-button btn--create" windeActionIcon>
                        <sui-svg-icon icon="plus-circle" windeGreen/>
                    </button>
                    <ul id="actionSelection" class="dropdown-menu" style="cursor: pointer; margin-top: -2px" [style.display]="isShowMenu">
                        @if (!isBomConfigFolderSelected()) {
                            <li class="dropdown-item"
                                (click)="openCreateDialog('projects/new')"
                                (keydown)="openCreateDialog('projects/new')">
                                {{ 'project.home.createLabel' | translate }}
                            </li>
                        }
                        <li class="dropdown-item"
                            (click)="openCreateDialog('folder/new')"
                            (keydown)="openCreateDialog('folder/new')">
                            {{ 'project.home.createFolder' | translate }}
                        </li>
                        @if (isBomConfigFolderSelected()) {
                            <li class="dropdown-item"
                                (click)="openCreateDialog('BOM/new')"
                                (keydown)="openCreateDialog('BOM/new')">
                                {{ 'project.home.createBOM' | translate }}
                            </li>
                        } @else if ((systemInfo$ | async).projectInterchange.importEnabled) {
                            <li *windeHasAnyAuthority="userAuthorities.ALL_SIKLU" class="dropdown-item"
                                (click)="openCreateDialog('projects/import')"
                                (keydown)="openCreateDialog('projects/import')">
                                {{ 'project.home.importProject' | translate }}
                            </li>
                        }
                    </ul>
                </div>
                @if (selectedFolder() && !selectedFolder().isRoot()) {
                    <winde-ctx-sensitive-help
                            placement="right"
                            tooltipTextPath="projects.folder.btn.edit"
                            [routerLink]="['', { outlets: { popup: ['folder', selectedFolder().id, 'edit'] } }]"
                            queryParamsHandling="preserve"
                    >
                        <button windeActionIcon>
                            <sui-svg-icon icon="pencil" windeOrange/>
                        </button>
                    </winde-ctx-sensitive-help>
                }
            </div>
        }
        <form [ngClass]="{ 'tree-search--active': isFilterActive() }" class="tree-search">
            <button windeActionIcon>
                <sui-svg-icon class="search" icon="search" windeGrey/>
            </button>
            <input
                    (ngModelChange)="changeFilter($event)"
                    [(ngModel)]="filter"
                    [ngModelOptions]="{ standalone: true }"
                    class="tree-search__inp"
                    required
                    type="text"
            />
            <winde-ctx-sensitive-help
                    [hidden]="!isFilterActive()"
                    placement="bottom"
                    style="vertical-align: middle; display: inline-block"
                    tooltipTextPath="projects.searchField.btn.clear"
            >
                <button (click)="clearFilter()" windeActionIcon>
                    <sui-svg-icon class="clear" icon="cross" windeRed/>
                </button>
            </winde-ctx-sensitive-help>
        </form>
    </div>
    <div class="tree-view__list-view-toggle">
        <winde-ctx-sensitive-help placement="left" tooltipTextPath="projects.folder.btn.showAsTable">
            <button (click)="changeCurrentViewType(viewType.TABLE)" windeActionIcon>
                <sui-svg-icon [ngClass]="{ active: isTableViewTypeSelected() }" icon="view-mode-list" windeGreen/>
            </button>
        </winde-ctx-sensitive-help>
        <winde-ctx-sensitive-help placement="left" tooltipTextPath="projects.folder.btn.showAsCards">
            <button (click)="changeCurrentViewType(viewType.CARDS)" windeActionIcon>
                <sui-svg-icon [ngClass]="{ active: !isTableViewTypeSelected() }" icon="view-mode-full" windeGreen/>
            </button>
        </winde-ctx-sensitive-help>
    </div>
</div>
